import { Badge, IconButton, IconButtonProps } from "@mui/material";
import { Iconify } from "app/components/Iconify";

type NotificationIconProps = IconButtonProps & {
  isPopoverOpened: boolean;
  numberOfUnreadNotifications: number;
};

export const NotificationIcon = ({
  isPopoverOpened,
  numberOfUnreadNotifications,
  ...other
}: NotificationIconProps) => {
  return (
    <IconButton color={isPopoverOpened ? "primary" : "default"} {...other}>
      <Badge badgeContent={numberOfUnreadNotifications} color="error">
        <Iconify icon="solar:bell-bing-bold-duotone" width={24} />
      </Badge>
    </IconButton>
  );
};
